import { render, staticRenderFns } from "./assignVehicle.vue?vue&type=template&id=5e7e65fc&scoped=true&"
import script from "./assignVehicle.vue?vue&type=script&lang=js&"
export * from "./assignVehicle.vue?vue&type=script&lang=js&"
import style0 from "./assignVehicle.vue?vue&type=style&index=0&id=5e7e65fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7e65fc",
  null
  
)

export default component.exports